<mat-dialog-content
  cdkDrag cdkDragRootElement=".cdk-overlay-pane"
  cdkDragHandle
>
  <div class="video-section">

    <div
      class="
        tw-flex
        tw-justify-end
        tw-absolute
        tw-top-[0px]
        tw-right-[0px]
        tw-cursor-pointer
        !tw-mt-[2px]
        tw-mr-[14px]
      "
    >
      <mat-icon (click)="closeDialog()">close</mat-icon>
    </div>

    @if (track) {
      <p class="tw-text-[14px] tw-text-center tw-pb-[10px]">
        {{ track }} - {{ breed }} - {{ 'generic.race' | translate: 'Race' }} {{ race }} <br/>
        {{ date | dateFormat: 'MM-DD-YYYY' }}
      </p>
    }

    <video
      #videoPlayer
      id="replyVideo"
      class="video-js vjs-default-skin"
      loop
      autoplay
      controls
      preload="auto"
      data-setup='{}'
      width="100%"
      height="243"
      padding="0"
    >
      <!-- <source [src]="safeUrl" type="application/x-mpegURL" /> -->
    </video>

    @if (showOdds && runners) {
      <table
        class="show-runners tw-w-[100%] tw-mt-[15px]"
      >
        <thead>
          <tr>
            <th><span>{{ 'generic.runner' | translate: 'Runner' }}</span></th>
            <th><span></span></th>
            <th class="tw-text-center"><span>{{ 'generic.ml' | translate: 'ML' }}</span></th>
            <th class="tw-text-center"><span>{{ 'generic.odds' | translate: 'Odds' }}</span></th>
          </tr>
        </thead>
        <tbody>
          @for (runner of runners; let i = $index; track i) {
            <tr class="tw-border-b tw-border-[#c3c3c4]">
              <td>
                <span [class.tw-line-through]="runner?.Odds === 'SCR'">
                  {{ runner?.Name }}
                </span>
              </td>
              <td>
                <span>{{ runner?.Id }}</span>
              </td>
              <td class="tw-text-center">
                <span [class.tw-line-through]="runner?.Odds === 'SCR'">
                  {{ runner?.ML ? runner?.ML : '-' }}
                </span>
              </td>
              <td class="tw-text-center">
                <span [class.tw-line-through]="runner?.Odds === 'SCR'">
                  {{ runner?.Odds ? runner?.Odds : '-' }}
                </span>
              </td>
            </tr>
          }
        </tbody>
      </table>

      <div
        class="replay-row tw-block tw-mt-[15px] tw-mb-[10px] tw-pl-[5px]"
      >
        <button
          (click)="showLatestFinishedEvent()"
          class="
            tw-uppercase
            tw-text-[15px]
            tw-bg-[#19385D]
            tw-text-[#FFFFFF]
            tw-px-[16px]
            tw-py-[4px]
            tw-rounded-[20px]
            tw-hover:bg-[#102940]
            tw-transition-colors
          "
        >
          {{ 'ui.wager.view.result' | translate: 'View Result' }}
        </button>
      </div>
    }

  </div>
</mat-dialog-content>
